import { type ComponentProps } from 'react';
import { Menu } from '@headlessui/react';
import clsx from 'clsx';

import styles from './Dropdown.module.css';

type DropdownProps = Omit<ComponentProps<typeof Menu>, 'as'>;

export default function Dropdown({ className, children, ...props }: DropdownProps) {
  return (
    <Menu
      as="div"
      className={clsx(styles.dropdown, className)}
      {...props}
    >
      {children}
    </Menu>
  );
}
